<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useCartStore } from '../stores/cart';

const { t } = useI18n({ useScope: 'global' });
const cart = useCartStore();
</script>

<template>
    <div class="cart-totals">
        <h3 class="cart-totals__heading">{{ t('cart.orderSummary') }}</h3>

        <div class="cart-totals__rows">
            <div class="cart-totals__row">
                <span>{{ t('cart.subtotal') }}</span>
                <span>{{ cart.cart?.itemSubtotalAsCurrency }}</span>
            </div>
            <div v-if="cart.cart && cart.cart.totalDiscount !== 0" class="cart-totals__row">
                <span>{{ t('cart.discount') }}</span>
                <span>{{ cart.cart.totalDiscountAsCurrency }}</span>
            </div>
            <div v-if="cart.cart && cart.cart.totalTaxIncluded !== 0" class="cart-totals__row">
                <span>{{ t('cart.tax') }}</span>
                <span>{{ cart.cart.totalTaxIncludedAsCurrency }}</span>
            </div>
            <div v-if="cart.cart && cart.cart.totalShippingCost !== 0" class="cart-totals__row">
                <span>{{ t('cart.shipping') }}</span>
                <span>{{ cart.cart.totalShippingCostAsCurrency }}</span>
            </div>
        </div>

        <div class="cart-totals__grand">
            <span>{{ t('cart.total') }}</span>
            <span>{{ cart.cart?.totalPriceAsCurrency }}</span>
        </div>
    </div>
</template>
